import rate from '@/assets/images/egg_rate.webp';
import common from '@/assets/images/egg_common.webp';
import mythic from '@/assets/images/egg_mythic.webp';
import avatar from '@/assets/images/default-avatar.png';


export const CONSTANTS = {
  BASE_PATH: "eggsvault",
  DOMAIN: process.env.DOMAIN,
  BASE_URL: process.env.VITE_BASE_URL,
  CAMPAIGN_URL: process.env.VITE_API_CAMPAIGN_URL,
  SMASH_ADDRESS: process.env.VITE_SMASH_ADDRESS,
  RPC: 'https://worldchain-mainnet.g.alchemy.com/public',
  RPCWLD: 'https://worldchain-mainnet.gateway.tenderly.co',
  APP_ID: process.env.VITE_APP_ID,
  DEFAULT_AVATAR: avatar,
  RECEIVER: process.env.VITE_RECEIVER,
  AMOUNT: 2.5,
  TOKEN_ADDRESS: process.env.VITE_TOKEN_ADDRESS, //WLD ADDRESS
  EVENT_LOG: process.env.VITE_EVENT_LOG, //TO GET EGG ADDRESS AFTER SMASHING EGGS
  SSE_URL: `${process.env.VITE_BASE_URL}/api/world-coin-chest-smasher/extra-eggs/payment/subscribe?wallet`,
  SSE_URL_SMASH: `${process.env.VITE_BASE_URL}/api/world-coin-chest-smasher/extra-eggs/smash/subscribe?wallet`,
  RECEIVE_SMASH: [
    {
      address: process.env.VITE_COMMON,
      title: 'Congrats! You’ve cracked a Common Egg!',
      img: common,
    },
    {
      address: process.env.VITE_RARE,
      title: 'Nice! An Rare Egg! More rewards ahead!',
      img: rate,
    },
    {
      address: process.env.VITE_MYTHIC,
      title: "Wow! A Mythic Egg! You're on fire!",
      img: mythic,
    },
  ],
  CONTRACT_PAY_TRANSFER: process.env.VITE_CONTRACT_PAY_TRANSFER,
};
